module.exports = __webpack_public_path__ + "static/pricing-logos-33048cd9942ff5d9e197dfa1fac76c52.png";